module.exports = __webpack_public_path__ + "media/images/favicn/favicon-32x32-3d4520ac2d43a659e7a4df1fc926ffb0.png";